import { memo, Suspense, useState } from 'react';

import { ModelProvider, SelectControlsProps } from '@spazious/dollhouse-engine';
import { useEventCallback } from '@spazious/react-hooks';

import { DragControls } from '../DragControls/index.js';
import { FArrangementControls } from '../FArrangementControls/index.js';
import { useFeatures } from '../Features/index.js';
import { FSetup } from '../FSetup/index.js';
import { Loader } from '../Loader/index.js';
import { SelectControls } from '../SelectControls/index.js';
import { Space } from '../Space/index.js';

export const Stage = memo(() => {
  const { hasFeature } = useFeatures();
  const nodeAttrsEditable = hasFeature('graphs.setup.node.attrs:editable');
  const nodeEditable = hasFeature('graphs.setup.node:editable');

  const [dragControlsEnabled, setDragControlsEnabled] = useState<boolean>(true);
  const handleSelectRange = useEventCallback<PickProp<SelectControlsProps, 'onSelectRange'>>(
    (evt) => {
      if (evt.phase === 'start') {
        setDragControlsEnabled(false);
      } else if (evt.phase === 'end') {
        setDragControlsEnabled(true);
      }
    }
  );

  return (
    <Suspense fallback={<Loader />}>
      <Space />
      <Suspense fallback={<Loader />}>
        <ModelProvider>
          <DragControls enabled={dragControlsEnabled && nodeEditable} />
          <SelectControls onSelectRange={handleSelectRange}>
            {nodeAttrsEditable && <FArrangementControls />}
            <FSetup />
          </SelectControls>
        </ModelProvider>
      </Suspense>
    </Suspense>
  );
});
